import { FC } from 'react';
import Edit from 'components/segments/components/Edit';

const Screen: FC = () => {
  return (
    <Edit
      segmentsEntityName="segment"
      segmentsEndpoint="segments"
      elementsEntityName="elements"
      elementsEndpoint="elements"
      segmentFilter="segment_id"
    />
  );
};

export default Screen;
